export const serviceItems = [
  {
    title: "Consulting",
    divClass: "consulting",
    image: "/images/ourservices/service-consulting.jpg",
    imgAlt: "People in a meeting reviewing documents",
    description: [
      {
        subHeading: "",
        bullets: [
          "We help investors and homeowners understand their rental options before purchasing a property. You may be curious to see how much a property can generate doing Short Term or Mid Term Rental? Or you’re unsure of the by-laws and permit requirements for a certain property?",
          "We can help consult on what are the best options for you based on the type of property, the local market and what’s happening in the industry.",
          "Depending on your needs, after an initial complimentary call, we can produce a 5-10 page document providing a thorough market & rental analysis. This document includes full analysis of your local area, by-laws & zoning, major competitions, suggested pricing strategy, average occupancy and best rental options available. There’s a $500 fee. This fee will be given back to you if you decide to hire us on as your property Short-Term or Mid-Term Co-Hosts/Management Team.",
        ],
      },
    ],
    pricing: "",
  },
  {
    title: "Account & Listing Set-up",
    divClass: "listing",
    image: "/images/ourservices/service-listing.jpg",
    imgAlt: "Someone typing on a laptop",
    description: [
      {
        subHeading: "",
        bullets: [
          "Help you create an Admin Hosting account + set up payout",
          "End-to-end listing creation",
          "Listing optimization",
          "Search engine optimization",
          "Multiple platforms",
        ],
      },
    ],
    pricing: "Fee: $300 for Airbnb ($100 on additional platforms)",
  },
  {
    title:
      "Co-hosting & Guests Management: 15-20% of revenue after cleaning fees",
    divClass: "management",
    image: "/images/ourservices/service-management.jpg",
    imgAlt: "Townhouses",
    description: [
      {
        subHeading: "Online Management",
        bullets: [
          "Reservation management across platforms",
          "Guest screening & communication",
          "Income maximizing pricing",
          "24/7 Concierge service",
        ],
      },
      {
        subHeading: "Check-in",
        bullets: [
          "Guest welcoming",
          "Key delivery",
          "Supplies restocking",
          "Automated scheduling",
        ],
      },
      {
        subHeading: "Check-out",
        bullets: [
          "Cleaning",
          "Laundry",
          "Property inspection",
          "Automated scheduling",
        ],
      },
      {
        subHeading: "Property Management",
        bullets: [
          "Coordinate with local specialized professionals (pool,hot tub,sauna, lawn care, snow removal)",
          "Laundry",
          "Coordinate with local handyman to do minor jobs",
          "Available for small and emergency jobs relating to the upkeep of the property",
        ],
      },
      {
        subHeading: "Accounting",
        bullets: ["Tracking of reservations & payout", "Tracking of expenses"],
      },
    ],
    pricing: "Fee: 15-20% of revenue after cleaning fees",
  },
  {
    title: "Travel Coordination",
    divClass: "travel",
    image: "/images/ourservices/service-travel.jpg",
    imgAlt: "Laptop and sunglasses on boardwalk by the beach",
    description: [
      {
        subHeading: "travel",
        bullets: [
          'Mai Nguyen & Jonathan Lim are also founders of Travel With the Lims, a TICO certified travel company associated with The FrontLiners Agency that specializes in group trips, ski & snowboarding trips. Interested in their travel concierge services? Email them at <a href="mailto:travelwiththelims@gmail.com">travelwiththelims@gmail.com</a> and a Travel Pro on their team can help you.',
        ],
      },
    ],
    pricing: "",
  },
  {
    title: "Financing",
    divClass: "financing",
    image: "/images/ourservices/service-financing.jpg",
    imgAlt:
      "Someone handing keys and miniature house to a person signing a contract",
    description: [
      {
        subHeading: "financing",
        bullets: [
          'Jonathan Lim is a certified Mortgage Specialist with Centum. He and  his team of  Mortgage professionals can also help you find various solutions to finance your property. For more details, contact Jonathan Lim at <a href="mailto:info@limmanagement.com">info@limmanagement.com</a>.',
        ],
      },
    ],
    pricing: "",
  },
];
